export const CONSTANT = {
  URL: "http://localhost:8080/api/",
  BASE_URL: "http://localhost:3000/",
}